import HeaderDetails from './HeaderDetails.container';

export default HeaderDetails;
